<template>
  <div class="columns">
    <div class="column is-half">
      <b-field label="Id">
        <b-input ref="qId" v-model="filterModel.Id"></b-input>
      </b-field>
      <b-field label="Titolo">
        <b-input ref="qTitolo" v-model="filterModel.Title"></b-input>
      </b-field>
      <b-field label="Titolo originale">
        <b-input ref="qTitolo" v-model="filterModel.OriginalTitle"></b-input>
      </b-field>
      <b-field label="Anno">
        <b-input ref="qAnno" v-model="filterModel.Year"></b-input>
      </b-field>
      <b-field label="Città">
        <b-select v-model="filterModel.City_id">
          <option v-for="city in lovs.city" :value="city.Id" :key="city.Id">
            {{ city.City }}
          </option>
        </b-select>
      </b-field>

      <b-field label="Servizio">
        <b-select v-model="filterModel.Service_id">
          <option
            v-for="service in lovs.service"
            :value="service.Id"
            :key="service.Id"
          >
            {{ serviceName(service) }}
          </option>
        </b-select>
      </b-field>
      <section>
        <div class="buttons">
          <b-button @click="doOkSearch" type="is-primary">Vai</b-button>
          <b-button @click="doClearSearch" type="is-primary"
            >Mastrolindo</b-button
          >
        </div>
      </section>
    </div>
    <div class="column">
      <b-field label="Data inizio">
        <b-datepicker
          ref="qDateStart"
          v-model="filterModel.DateStart"
          editable
          :date-formatter="isoDate"
        >
        </b-datepicker>
      </b-field>
      <b-field label="Data fine">
        <b-datepicker
          ref="qDateEnd"
          v-model="filterModel.DateEnd"
          editable
          :date-formatter="isoDate"
        >
        </b-datepicker>
      </b-field>
      <b-field label="Cazzetti">
        <b-input ref="qDicks" v-model="filterModel.Dicks"></b-input>
      </b-field>
      <b-field label="Modalità">
        <b-select v-model="filterModel.Mode_id">
          <option v-for="mode in lovs.mode" :value="mode.Id" :key="mode.Id">
            {{ mode.Mode }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Lingua">
        <b-select v-model="filterModel.Language_id">
          <option v-for="lng in lovs.language" :value="lng.Id" :key="lng.Id">
            {{ lng.Language }}
          </option>
        </b-select>
      </b-field>
      <b-taginput
        v-model="filterModel.Friends"
        :data="filteredTags"
        autocomplete
        :allow-new="false"
        :open-on-focus="false"
        field="Friend"
        icon="label"
        placeholder="Amici..."
        @typing="getFilteredTags"
      >
      </b-taginput>
    </div>
  </div>
</template>

<script>
import helpers from "../helpers.js";
import api from "../api/api.js";
let emptyVal = { id: 0, Dicks: 0 };

export default {
  name: "SearchVision",
  methods: {
    serviceName(service) {
      if (service.Room) return service.Name + " - " + service.Room;
      else return service.Name;
    },
    buildActiveLovs() {
      // this.lovs.language = this.$store.state.languages;
      // this.lovs.service = this.$store.state.services;
      // this.lovs.city = this.$store.state.cities;
      // this.lovs.mode = this.$store.state.modes;
      // this.lovs.friend = this.$store.state.friends;
    },
    modeSelected(value) {
      var selected = this.lovs.mode.filter((x) => {
        return x.Id == value;
      })[0];
      this.showServices = selected.Mode == "Service";
    },
    isoDate(date) {
      return helpers.buildIsoDate(date);
    },
    doClearSearch() {
      this.filterModel = {};
    },
    doOkSearch() {
      this.$emit("OkSearch", this.filterModel);
    },
    getFilteredTags(text) {
      this.filteredTags = this.lovs.friend.filter((option) => {
        return (
          option.Friend.toString().toLowerCase().indexOf(text.toLowerCase()) >=
          0
        );
      });
    },
  },
  data() {
    return {
      selectedRow: null,
      newItem: emptyVal,
      lovs: { city: [] },
      filterModel: {},
      filteredTags: [],
    };
  },
  mounted() {
   
   
       const loading = this.$buefy.loading.open();
      api.lovs().then((data) => {
        this.lovs.language = data.data.languages;
        this.lovs.city = data.data.cities;
        this.lovs.friend = data.data.friends;
        this.lovs.mode = data.data.modes;
        this.lovs.service = data.data.services;
        //this.buildActiveLovs();
        loading.close();
      });
    
  },
};
</script>

<style>
</style>
